import { ExplorationsFileExportsComponent } from '@mode/explorations/shell';
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

export const DowngradedExplorationsShellModule = angular
  .module('downgraded-explorations-shell', [])
  .directive('modeExplorationsFileExports', downgradeComponent({ component: ExplorationsFileExportsComponent })).name;
